(() => {
  let animationFrame;

  const CARD_SELECTOR = '.card__container';
  const GROUP_SELECTOR = '.collection__grid, .swiper-wrapper';

  function isVisible(element) {
    if (!element) return false;

    const style = window.getComputedStyle(element);
    const rect = element.getBoundingClientRect();

    return (
      style.display !== 'none' &&
      style.visibility !== 'hidden' &&
      rect.width > 0 &&
      rect.height > 0
    );
  }

  function getInfoBlock(card) {
    return card.querySelector('.garvin-product-card > a.card');
  }

  function getVisibleQuickAdd(card) {
    const quickAdds = card.querySelectorAll(
      '.card__quick-add-container--desktop, .card__quick-add-container--mobile'
    );

    return Array.from(quickAdds).find(isVisible);
  }

  function getCardsInGroup(group) {
    return Array.from(group.querySelectorAll(CARD_SELECTOR)).filter((card) => {
      const closestGroup = card.closest(GROUP_SELECTOR);
      const infoBlock = getInfoBlock(card);
      const quickAdd = getVisibleQuickAdd(card);

      return closestGroup === group && infoBlock && quickAdd;
    });
  }

  function splitCardsByRow(cards, isGrid) {
    if (!isGrid) return [cards];

    const rows = [];

    cards.forEach((card) => {
      const cardTop = Math.round(card.getBoundingClientRect().top);

      let row = rows.find((item) => Math.abs(item.top - cardTop) <= 4);

      if (!row) {
        row = {
          top: cardTop,
          cards: []
        };

        rows.push(row);
      }

      row.cards.push(card);
    });

    return rows.map((row) => row.cards);
  }

  function alignButtons(cards) {
    if (cards.length < 2) return;

    /* Reinicia medidas anteriores antes de recalcular */
    cards.forEach((card) => {
      const infoBlock = getInfoBlock(card);

      if (infoBlock) {
        infoBlock.style.minHeight = '';
      }
    });

    const measurements = cards
      .map((card) => {
        const infoBlock = getInfoBlock(card);
        const quickAdd = getVisibleQuickAdd(card);

        if (!infoBlock || !quickAdd) return null;

        const cardRect = card.getBoundingClientRect();
        const quickAddRect = quickAdd.getBoundingClientRect();
        const infoRect = infoBlock.getBoundingClientRect();

        return {
          infoBlock,
          buttonPosition: quickAddRect.top - cardRect.top,
          infoHeight: infoRect.height
        };
      })
      .filter(Boolean);

    if (measurements.length < 2) return;

    const targetPosition = Math.max(
      ...measurements.map((item) => item.buttonPosition)
    );

    measurements.forEach((item) => {
      const difference = Math.ceil(
        targetPosition - item.buttonPosition
      );

      if (difference > 0) {
        item.infoBlock.style.minHeight = `${Math.ceil(
          item.infoHeight + difference
        )}px`;
      }
    });
  }

  function runAlignment() {
    document.querySelectorAll(GROUP_SELECTOR).forEach((group) => {
      const cards = getCardsInGroup(group);

      if (cards.length < 2) return;

      const isGrid = group.classList.contains('collection__grid');
      const rows = splitCardsByRow(cards, isGrid);

      rows.forEach(alignButtons);
    });
  }

  function scheduleAlignment() {
    window.cancelAnimationFrame(animationFrame);

    animationFrame = window.requestAnimationFrame(() => {
      window.requestAnimationFrame(runAlignment);
    });
  }

  document.addEventListener('DOMContentLoaded', scheduleAlignment);
  window.addEventListener('load', scheduleAlignment);
  window.addEventListener('resize', scheduleAlignment);

  document.addEventListener('shopify:section:load', scheduleAlignment);
  document.addEventListener('shopify:section:reorder', scheduleAlignment);

  new MutationObserver(scheduleAlignment).observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  scheduleAlignment();
})();